<template>
    <div class="Datepicker-dropdown-calendar-time">
        <select v-model="hour" class="Select sm" :disabled="readonly">
            <option v-for="h in hours" :key="h" :value="h">{{ formatNumber(h) }}</option>
        </select>
        :<select v-model="minute" class="Select sm" :disabled="readonly">
            <option v-for="m in minutes" :key="m" :value="m" >{{ formatNumber(m) }}</option>
        </select>
        <template v-if="secondPicker">
            :<select v-model="second" class="Select sm" :disabled="readonly">
                <option v-for="s in 60" :key="s-1" :value="s-1">{{ formatNumber(s-1) }}</option>
            </select>
        </template>
        <select v-if="!hour24" v-model="ampm" class="Select sm" :disabled="readonly">
            <option value="AM">AM</option>
            <option value="PM">PM</option>
        </select>
    </div>
</template>

<script>
import props    from './utils/CalendarTime/props.js';
import watches  from './utils/CalendarTime/watches.js';
import methods  from './utils/CalendarTime/methods.js';
import computed from './utils/CalendarTime/computed.js';

export default
{
    name    : "CalendarTime",
    mixins  : [ props, computed, methods, watches ],

    data()
    {
        let current = this.currentTime ? this.currentTime : new Date();

        if( !this.currentTime )
        {
            current.setHours( 0, 0, 0, 0 );
        }

        let hours = current.getHours();

        return (
        {
            hour    : this.hour24 ? hours : hours % 12 || 12,
            minute  : current.getMinutes() - ( current.getMinutes() % this.miniuteIncrement ),
            second  : current.getSeconds(),
            ampm    : hours < 12 ? 'AM' : 'PM',
        });
    }
}
</script>

<style lang="scss">
.Datepicker-dropdown-calendar-time
{
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;

    gap: px(4);

    padding: 0 px(16) px(24) px(16);

    > select
    {
        text-align: center;
    }
}
</style>